<script>
	const name = 'FYRING';
	export let view = 0;
	import { language } from './stores.js';
function openNav() {
	console.log("open")
  document.getElementById("mySidenav").style.width = "100%";
}

function closeNav() {
	console.log("close")
  document.getElementById("mySidenav").style.width = "0";
}
function openHome() {
	console.log("home")
	window.open("https://www.fyring.se","_self");
}
</script>
<div id="header">

	<div id="mySidenav" class="sidenav">
		<!-- svelte-ignore a11y-missing-attribute -->
		<a href="javascript:void(0)" class="closebtn" on:click={closeNav}>&times</a>
		<button
						class="{view === 0 ? 'selected' : ''}"
						on:click={() => {view = 0; closeNav()}}>
						{#if $language == 0}hem
						{:else}home
						{/if}

		</button>

		<button
						class="{view === 1 ? 'selected' : ''}"
						on:click={() => {view = 1; closeNav()}}>
						{#if $language == 0}snaps
						{:else}snaps
						{/if}

		</button>

		<button
					class="{view === 3 ? 'selected' : ''}"
					on:click={() => {view = 3; closeNav()}}>
					{#if $language == 0}		stickan
					{:else}		stickan
					{/if}

		</button>
		<button
						class="{view === 2 ? 'selected' : ''}"
						on:click={() => {
							view = 2;
							closeNav()}}>
							{#if $language == 0}kontakt
							{:else}contact
							{/if}

		</button>
	</div>
	<div id="hamdiv" style="width: 10%;display: inline-block;">
	<span style="font-size:30px;cursor:pointer" on:click={openNav}>&#9776;</span>
	</div>
	<h1 on:click={openHome}>{name}</h1>
</div>

<style>
#header{
	width: 100%;
	margin-bottom: 30px;
}
h1{
	margin: 10px 25% 10px 14%;
	width: 50%;
	display: inline-block;
	font-family: 'Flightcase Regular','FlightcaseTwo', Serif;
	text-align:center;
}
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  text-align:center;
}

.sidenav button {
	font-family: 'Abril Fatface';
  padding: 8px auto;
  text-decoration: none;
  font-size: 30px;
  color: #F4F2EF;
  display: block;
  transition: 0.3s;
	border: none;
	background-color: transparent;
	cursor: pointer;
	text-align: center;
	margin: auto;
}

.sidenav a:hover{
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
.selected{
		border-bottom: 5px solid red;
}


</style>
